<app-alert
  *ngIf="
    activeImport &&
    features.controls.length &&
    features.errors &&
    features.errors['differences']
  "
  header="Unterschiedliche Schlüssel gefunden"
  text="Die Schlüssel aus der Import-Datei und den aktuellen Geodaten unterscheiden sich!"
  [severity]="type === 'Point' ? 'warning' : 'error'">
  <p>
    Da Ihre Daten fest mit den Schlüsseln verbunden sind, würde hier die
    Verknüpfung verloren gehen!
  </p>
  <p>
    Sie können die Schlüssel vor dem Import händisch anpassen, um diesen
    durchzuführen.
  </p>
  <p>
    <strong
      >Stellen Sie im Falle einer manuellen Korrektur sicher, dass die fehlenden
      oder fehlerhaften Schlüssel richtig zugeordnet werden.</strong
    >
  </p>
  <p>Folgende Schlüssel wurden in der Import-Datei <u>nicht</u> gefunden:</p>

  <ul>
    @for (key of features.errors['differences']; track $index) {
      <li>
        <code>{{ key }}</code
        ><span>: {{ getFeatureNameByKey(key) }}</span>
      </li>
    }
  </ul>
</app-alert>

@if (
  features.errors &&
  features.errors['differences'] &&
  !features.errors['nonUniqueKeys']
) {
  <app-alert
    header="Geo-Daten Überschreiben"
    [canToggle]="false"
    styleClass="p-3 pt-1"
    text=""
    severity="warning">
    <p>
      Es wird dringend empfohlen die Gebietsschlüssel nicht zu verändern, falls
      Sie bereits Daten hinterlegt haben und Ihre Geodaten überschreiben wollen.
    </p>
    <p>
      Die Verbindung zu den Daten geht ansonsten verloren, was zur Folge hat,
      dass Sie alle Daten neu hochladen müssen.
    </p>

    <p-checkbox
      [(ngModel)]="ignoreDifferentKeysValidator"
      [binary]="true"
      label="verstanden, überschreiben aktivieren"></p-checkbox>
  </app-alert>
}

<app-alert
  header="Identische Schlüssel gefunden"
  text="Stellen Sie sicher, dass alle zu Importierende Schlüssel unique
      sind!"
  severity="error"
  *ngIf="features.errors && features.errors['nonUniqueKeys']">
  <p>Folgende doppelte Schlüssel wurden in der Import-Datei gefunden:</p>
  <ul>
    <li *ngFor="let key of features.errors?.['nonUniqueKeys']">
      <code>{{ key }}</code>
    </li>
  </ul>
</app-alert>

@if (features.controls.length) {
  <div class="flex align-items-center">
    <app-header
      [icon]="type === 'Point' ? 'fas fa-location-dot' : 'fas fa-circle-nodes'"
      [text]="headerText"></app-header>

    @if (filteredFeatures) {
      <app-search-input
        class="ml-auto"
        placeholder="durchsuchen ..."
        (search)="onSearch($event)">
      </app-search-input>
    }
  </div>
}

@if (isReadonly) {
  <p-table [value]="currentFeatures" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th>Schlüssel</th>
        <th>Name</th>
        <th>Gruppe</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-feature>
      <tr>
        <td>{{ feature.properties?.['key'] || '' }}</td>
        <td>{{ feature.properties?.['name'] || '' }}</td>
        <td>{{ feature.properties?.['group'] || '' }}</td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <div [formGroup]="featureForm" class="p-fluid" *ngIf="filteredFeatures">
    <div
      class="px-3 pt-1 pb-2"
      appAlertStyle="info"
      *ngIf="
        (!features.controls.length && !geoDataStore.selectedId()) ||
        convertAvailable
      ">
      <app-header
        icon="fas fa-circle-info"
        [text]="
          activeImport
            ? 'Adressen erkannt – Koordinaten folgen'
            : 'Keine Geodaten vorhanden'
        "></app-header>
      <p>
        @if (convertAvailable) {
          <p>
            Die Adressen in Ihrer Datei werden im nächsten Schritt in
            Geokoordinaten umgewandelt. Bitte kontrollieren Sie danach, ob alle
            Standorte korrekt platziert wurden.
          </p>
          <div class="flex align-items-center gap-3">
            <p-button
              severity="secondary"
              [rounded]="true"
              [outlined]="true"
              icon="fas fa-xmark-circle"
              label="abbrechen"
              (click)="cancel()"></p-button>
            <p-button
              class="ml-auto"
              [rounded]="true"
              icon="fas fa-wand-magic-sparkles"
              label="Adressen umwandeln"
              (click)="triggerConvert.emit()">
            </p-button>
          </div>
        } @else if (!activeImport && type === 'Point') {
          Im gewählten Jahr sind keine Standorte vorhanden. Bitte überprüfen Sie
          Ihre Auswahl.
        } @else if (!activeImport) {
          <p>
            Sie können auch ohne Geodaten starten, indem Sie Daten mit
            Teilraumbezug hochladen.
          </p>
          <p>
            <strong class="flex align-items-baseline gap-2"
              ><i class="fas fa-exclamation-circle"></i> Name und Schlüssel der
              Teilräume werden dabei aus den Daten übernommen.</strong
            >
          </p>
          <p>
            Beim späteren Geodatenimport müssen diese exakt übereinstimmen,
            <b
              >damit die Daten automatisch verknüpft und in Karten dargestellt
              werden können.</b
            >
          </p>
        }
      </p>
    </div>
    <app-alert
      styleClass="p-3"
      [canToggle]="false"
      severity="info"
      *ngIf="
        features.controls.length && filteredControls && !filteredControls.length
      ">
      <span class="flex gap-2 align-items-center"
        ><i class="fas fa-info-circle"></i> Keine Einträge gefunden</span
      >
    </app-alert>
    <p-scrollPanel styleClass="h-24rem">
      <div formArrayName="features">
        <div
          *ngFor="let feature of filteredControls; let i = index"
          [formGroupName]="i">
          <div class="grid" formGroupName="properties">
            <app-form-field-wrapper
              [label]="'Schlüssel'"
              [name]="'key'"
              [colSize]="3">
              <input
                pInputText
                id="key"
                type="text"
                formControlName="key"
                class="p-input" />
            </app-form-field-wrapper>

            <app-form-field-wrapper
              [label]="'Name'"
              [name]="'name'"
              [colSize]="5">
              <input
                pInputText
                id="name"
                type="text"
                formControlName="name"
                class="p-input" />
            </app-form-field-wrapper>

            <app-form-field-wrapper
              [label]="'Gruppe'"
              [name]="'group'"
              [colSize]="3">
              <input
                pInputText
                id="group"
                type="text"
                formControlName="group"
                class="p-input" />
            </app-form-field-wrapper>

            <app-form-field-wrapper [hideLabel]="true" [colSize]="1">
              <p-button
                *ngIf="!editMenuAvailable"
                (click)="removeFeature(i)"
                icon="fas fa-trash"
                [severity]="'danger'"
                [size]="'small'"
                [rounded]="true"></p-button>
              <p-button
                [plain]="true"
                [text]="true"
                [size]="'small'"
                role="button"
                class="p-panel-header-icon p-panel-toggler p-link"
                [rounded]="true"
                (click)="openMenu($event, i, feature); this.menu.toggle($event)"
                icon="fas fa-ellipsis-vertical"></p-button>
              <p-menu #menu [model]="items" [popup]="true" appendTo="body" />
            </app-form-field-wrapper>
          </div>
        </div>
      </div>
    </p-scrollPanel>
    @if (inputFeatures || (currentFeatures && currentFeatures.length)) {
      @if (type === 'Point' && layerSiblings && layerSiblings.length > 0) {
        <p-divider></p-divider>
        <app-header
          sub="Standorte können in mehreren Jahren gespeichert bzw. importiert werden. Jahre, die aktuell identische Standorte nutzen sind vorausgewählt. Das oben ausgewählte Jahr wird immer gespeichert."
          icon="fas fa-calendar-check"
          text="In mehreren Jahren speichern"></app-header>

        <app-year-list
          [disabledYears]="selectedLayer ? [selectedLayer.year] : undefined"
          selectionMode="multiple"
          [dataLayers]="layerSiblings"></app-year-list>

        @if (overrideLayersByDifferences) {
        <p
          class="text-color-secondary font-italic text-sm flex gap-2 align-items-baseline">
          <i class="fas fa-info-circle"></i>
          <span>
            <b>Hinweis:</b> Die Standorte aus dem aktuell ausgewählten Jahr oben
            werden in die hier aktivierten Jahr übernommen. So können Sie
            dieselben Standorte einfach in mehreren Jahren speichern.“
          </span>
          </p>
        }
      }
      <p-divider></p-divider>
      <div class="flex gap-3">
        <!--<p-button
        type="button"
        [severity]="'success'"
        [styleClass]="'w-auto'"
        icon="fas fa-circle-plus"
        [rounded]="true"
        label="Teilraum hinzufügen"
        (click)="addFeature()"></p-button>-->

        @if (activeImport) {
          <p-button
            severity="secondary"
            [styleClass]="'w-auto'"
            icon="fas fa-times"
            [rounded]="true"
            [text]="true"
            label="abbrechen"
            (click)="cancel()"></p-button>
        }

        <p-button
          [disabled]="
            !ignoreDifferentKeysValidator &&
            (!features.controls.length ||
              (features.errors &&
                features.errors['differences'] &&
                type === 'Polygon'))
          "
          class="ml-auto"
          type="button"
          [severity]="
            type === 'Point' &&
            features.errors &&
            features.errors['differences']
              ? 'warning'
              : 'primary'
          "
          [styleClass]="'w-auto'"
          icon="fas fa-save"
          [rounded]="true"
          label="speichern"
          (click)="submitForm()"></p-button>
      </div>
    }
  </div>
}

@if (featureToEdit) {
  <p-sidebar
    (onHide)="closeMetaForm()"
    position="right"
    [modal]="false"
    [styleClass]="'w-7'"
    [visible]="!!featureToEdit">
    <ng-template pTemplate="header">
      <app-header icon="fas fa-pen" text="Feature bearbeiten"></app-header
    ></ng-template>
    <app-feature-meta-form
      (featureUpdated)="updateFeature($event)"
      (closeMetaForm)="closeMetaForm()"
      [featureToEdit]="featureToEdit"></app-feature-meta-form>
  </p-sidebar>

  <app-mask [visible]="!!featureToEdit" (click)="closeMetaForm()"></app-mask>
}
